import * as THREE from 'three';
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { EffectComposer } from 'three/addons/postprocessing/EffectComposer.js';
import { RenderPass } from 'three/addons/postprocessing/RenderPass.js';
import { BloomPass } from 'three/addons/postprocessing/BloomPass.js';
import { BokehPass } from 'three/addons/postprocessing/BokehPass.js';

import { OutputPass } from 'three/addons/postprocessing/OutputPass.js';

import { ShaderPass } from 'three/addons/postprocessing/ShaderPass.js';

import { RGBELoader } from 'three/addons/loaders/RGBELoader.js';
import { SMAAPass } from 'three/addons/postprocessing/SMAAPass.js';
import * as TWEEN from '@tweenjs/tween.js';
import { processProduct } from './utils.js'; // Make sure to import processProduct
import {
    getSKU

} from './script.js';
import html2canvas from 'html2canvas';

let card;
export let is3DRenderingActive;
let scene, camera, renderer, controls, composer, theta = 0, table, envMap, container;
let animationId = null;
const materialMap = new Map();

function clickCardFace(intersectedObject) {
    console.log("Entering clickCardFace");  // Debug line
    
    const targetPosition = intersectedObject.position.clone();
    console.log("Target Position:", targetPosition);  // Debug line
    
    // Calculate the direction from the object to the camera
    const direction = new THREE.Vector3().subVectors(camera.position, targetPosition).normalize();
    
    // Scale the direction vector to set a safe distance from the object, say 2.5 units to keep it zoomed out
    const scaledDirection = direction.clone().multiplyScalar(2.5);
    
    // Move along the scaled direction vector to set an offset position
    const offsetPosition = targetPosition.clone().add(scaledDirection);
    
    // Set the y component of the offset position to be higher than the target position,
    // to simulate a top-down view like viewing it from a table.
    offsetPosition.x = targetPosition.x;
    offsetPosition.z = 3;
    
    console.log("Offset Position:", offsetPosition);  // Debug line
  
    const startPosition = camera.position.clone();
    console.log("Start Position:", startPosition);  // Debug line
    
    const startFocalLength = camera.getFocalLength();
    const endFocalLength = 60;  // You can adjust this value as needed
  
    const tween = new TWEEN.Tween({ position: startPosition, focalLength: startFocalLength })
        .to({ position: offsetPosition, focalLength: endFocalLength }, 2000)
        .easing(TWEEN.Easing.Quadratic.Out)
        .onUpdate(({ position, focalLength }) => {
            console.log("Tween onUpdate:", position);  // Debug line
            camera.position.set(position.x, position.y, position.z);
            camera.lookAt(targetPosition);  // Look at the object's position, not the scene center
            camera.setFocalLength(focalLength);
        })
        .start();
}


export const initScene = async (product_type, page_size) => {
  


    const loadingScreen = document.getElementById('loadingScreen');
    
    loadingScreen.style.display = 'flex';
  
    try {
      scene = new THREE.Scene();
      container = document.getElementById('threeJSContainer');
      if (!container) {
        console.error('threeJSContainer element not found!');
        return;
      }


  
      setupCamera();
  
      // Load multiple assets in parallel
      await Promise.all([
        setupRendererAndEnvMap(),
        product_type === 'card' ? createGreetingCard() : createAcrylic(page_size)
    ]);
      setupTable();
      setupLighting();
     setupPostProcessing();
      setupOrbitControls();
  
      
      is3DRenderingActive = true;
      const event = new Event('3dRenderingStatus');
      event.status = true;  // Set to true when 3D rendering is activated
      document.dispatchEvent(event);
  
      loadingScreen.style.display = 'none';

    } catch (err) {
      console.error('Error initializing scene:', err);
      loadingScreen.innerHTML = 'An error occurred while loading. Please try again.';
    }
  
    animateOrbit();
  };
  
  
  const setupCamera = () => {
    camera = new THREE.PerspectiveCamera(50, container.offsetWidth / container.offsetHeight, 0.1, 1000);
    camera.setFocalLength(45);
    
    // Increase the y component to move the camera higher
    camera.position.set(0, 5, 0.6);  // The '5' here moves the camera higher along the y-axis
    
    camera.lookAt(7, 0.55, 10);
};

const setupRendererAndEnvMap = async () => {
    renderer = new THREE.WebGLRenderer({ antialias: true, preserveDrawingBuffer: true });
//    / renderer.setPixelRatio(window.devicePixelRatio); 
    renderer.setSize(container.offsetWidth, container.offsetHeight);
    renderer.setSize(window.innerWidth * 2, window.innerHeight * 2, false);
    renderer.shadowMap.enabled = true;
   renderer.toneMapping = THREE.CineonToneMapping;
   renderer.toneMappingExposure = 0.7;
    

    renderer.shadowMap.type = THREE.PCFSoftShadowMap; // default THREE.PCFShadowMap

    container.innerHTML = '';  // Clear existing content
    container.appendChild(renderer.domElement);
    const pmremGenerator = new THREE.PMREMGenerator(renderer);
    renderer.domElement.addEventListener('click', onDocumentMouseClick, false);

  
    return new Promise((resolve) => {
        new RGBELoader().setDataType(THREE.HalfFloatType)
            .load('http://ec-i.s3.eu-west-2.amazonaws.com/room_hdr.hdr', (texture) => {
                envMap = pmremGenerator.fromEquirectangular(texture).texture;
                scene.background = envMap;
                scene.environment = envMap;
                texture.dispose();
                resolve();
            });
    });
};

const setupTable = () => {
    const tableTexture = new THREE.TextureLoader().load('https://ec-i.s3.eu-west-2.amazonaws.com/floor_texture.jpg');
    const tableMaterial = new THREE.MeshPhysicalMaterial({
        map: tableTexture,
        color: 0xFFFFFF,
        metalness: 0.9,
        roughness: 0.2,
        envMap: envMap,
        envMapIntensity: 0.7,
        transparent: true,
        opacity: 0.9,
        refractionRatio: 0.98
    });

    // A4 card size adjusted to match real A4 dimensions in meters
    const cardWidth =1.4; // A4 width in meters
    const cardHeight = 1; // A4 height in meters
    
    // New table dimensions, larger than the greeting card
    const tableWidth = cardWidth * 4; // Width of the table is 4 times the width of the card
    const tableLength = cardHeight * 6; // Length of the table is 6 times the height of the card
    const tableThickness = 0.05; // Average thickness of a table top is around 5 cm

    table = new THREE.Mesh(new THREE.BoxGeometry(tableLength, tableThickness, tableWidth), tableMaterial);
    table.position.y = -tableThickness / 2; // Position the table such that its top is at y=0

    table.receiveShadow = true;
    scene.add(table);
};
const setupLighting = () => {
    const ambientLight = new THREE.AmbientLight(0x404040, 1);
    scene.add(ambientLight);

   // Adding high-quality light settings, maybe even more than one light source
const directionalLight = new THREE.DirectionalLight(0xFFFFFF, 0.8);
directionalLight.position.set(1, 3, 2);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.width = 1024;  // Increase this for better shadow quality
directionalLight.shadow.mapSize.height = 1024; // Increase this for better shadow quality
scene.add(directionalLight);


    const pointLight = new THREE.PointLight(0xFFFFFF, 1);
    pointLight.position.set(2, 4, 3);
    scene.add(pointLight);

     // Adding a RectAreaLight
     const rectLight = new THREE.RectAreaLight(0xFFFFFF, 1, 1, 1);
     rectLight.position.set(0, 1, 0.5);  // Position it in front of the front cover
     rectLight.lookAt(0, 1, 0);  // Make it look towards the front cover
     scene.add(rectLight);
 

};

const setupPostProcessing = () => {
    composer = new EffectComposer(renderer);
    
    // Render Pass
    composer.addPass(new RenderPass(scene, camera));
 // High-quality bloom
 composer.addPass(new BloomPass(0.8, 10, 0.4, 2048));

   
 // Depth of Field
composer.addPass(new BokehPass(scene, camera, {
    focus: 1.0, // Adjusted to bring the focus closer
    aperture: 0.02, // Increased to enhance the depth of field effect
    maxblur: 0.003, // Increased for more pronounced blurring
    width: container.offsetWidth * window.devicePixelRatio,
    height: container.offsetHeight * window.devicePixelRatio
}));


    // Tone Mapping
 //  composer.addPass(new AdaptiveToneMappingPass(THREE.CineonToneMapping, 0.2));

 renderer.toneMapping = THREE.CineonToneMapping;
renderer.toneMappingExposure = 0.5; // Adjust exposure to your liking


    // Anti-Aliasing
    composer.addPass(new SMAAPass(window.innerWidth * 0.5, window.innerHeight * 0.5));

    
   const outputPass = new OutputPass();
   composer.addPass(outputPass);


   
};


let frontCover, backCover, insideLeft, insideRight;
const createGreetingCard = async () => {

    const ecid = await processProduct('card'); // Fetch the ID


    const cardWidth = 1.4; // Width of the full card
    const cardHeight = 1;  // Height of the card

    const scaleFactor = 1 / 600;  // Scale factor to make the card 20 times smaller
    const loader = new THREE.TextureLoader();

    // Function to load texture
   // Function to load texture
   async function loadTextureAndFit(url) {
    return new Promise((resolve, reject) => {
        loader.load(
            url,
            (texture) => {
                texture.wrapS = THREE.ClampToEdgeWrapping;
                texture.wrapT = THREE.ClampToEdgeWrapping;
                texture.needsUpdate = true;
                resolve(texture);
            },
            undefined,
            (error) => {
                console.error("Error loading texture", error);
                reject(error);
            }
        );
    });
}

    // Read the dimensions of the div elements for each card face and scale them down
    const divFront = document.getElementById('front_cover-container').getBoundingClientRect();
    const divInsideLeft = document.getElementById('inside_left-container').getBoundingClientRect();
    const divInsideRight = document.getElementById('inside_right-container').getBoundingClientRect();


    // Load textures
    const uniqueId = Date.now();  // Use a timestamp or any other unique value
    const imageUrls = {
        frontCover: `https://i.expresscreations.co.uk/uploads/${ecid}-front_cover.png?${uniqueId}`,
        backCover: `https://ec-i.s3.eu-west-2.amazonaws.com/back_cover.png?${uniqueId}`,
        insideLeft: `https://i.expresscreations.co.uk/uploads/${ecid}-inside_left.png?${uniqueId}`,
        insideRight: `https://i.expresscreations.co.uk/uploads/${ecid}-inside_right.png?${uniqueId}`
    };
    
    // Load textures with the constructed URLs
    const frontCoverTexture = await loadTextureAndFit(imageUrls.frontCover);
    
    const insideLeftTexture = await loadTextureAndFit(imageUrls.insideLeft);
    const insideRightTexture = await loadTextureAndFit(imageUrls.insideRight);


    const backCoverTexture = await loadTextureAndFit('https://ec-i.s3.eu-west-2.amazonaws.com/back_cover.png');

    // Create materials
    const frontCoverMaterial = new THREE.MeshStandardMaterial({ map: frontCoverTexture });
    const insideLeftMaterial = new THREE.MeshStandardMaterial({ map: insideLeftTexture });
    const insideRightMaterial = new THREE.MeshStandardMaterial({ map: insideRightTexture });
    const backCoverMaterial = new THREE.MeshStandardMaterial({ map: backCoverTexture });

    // Create PlaneGeometry based on div dimensions and scale them down
    const frontCoverGeometry = new THREE.PlaneGeometry(divFront.width * scaleFactor, divFront.height * scaleFactor);
    const insideLeftGeometry = new THREE.PlaneGeometry(divInsideLeft.width * scaleFactor, divInsideLeft.height * scaleFactor);
    const insideRightGeometry = new THREE.PlaneGeometry(divInsideRight.width * scaleFactor, divInsideRight.height * scaleFactor);

    // Create meshes
    // Create meshes
    
   
// Geometry for half of the card using PlaneGeometry
const halfCardGeometry = new THREE.PlaneGeometry(cardWidth / 2, cardHeight);

const adjustment = 16 * scaleFactor; // 20px, scaled down
    
// Front Cover (remains the same)
 frontCover = new THREE.Mesh(halfCardGeometry, insideLeftMaterial);
frontCover.position.x = -cardWidth / 4 + adjustment; // Adjusted
frontCover.rotation.y = Math.PI / 8;

// Back Cover (switched with inside left)
 backCover = new THREE.Mesh(halfCardGeometry, insideRightMaterial);
backCover.position.x = cardWidth / 4 - adjustment; // Adjusted
backCover.rotation.y = -Math.PI / 8;

// Inside Right (remains the same)
 insideRight = new THREE.Mesh(halfCardGeometry, frontCoverMaterial);
insideRight.position.x = -cardWidth / 4 + adjustment; // Adjusted
insideRight.rotation.y = Math.PI + Math.PI / 8;

// Inside Left (switched with back cover)
 insideLeft = new THREE.Mesh(halfCardGeometry, backCoverMaterial);
insideLeft.position.x = cardWidth / 4 - adjustment; // Adjusted
insideLeft.rotation.y = -Math.PI - Math.PI / 8;
frontCover.castShadow = true;
backCover.castShadow = true;
insideLeft.castShadow = true;
insideRight.castShadow = true;

   // Adjust positions so that it stands on its base (scaled down)
   frontCover.position.z = 0.005;  // Half of 0.01, to bring it slightly forward
   backCover.position.z = 0.005;
   insideLeft.position.z = -0.005;  // Place it slightly behind
   insideRight.position.z = -0.005;


    // Position the card to stand upright
    const card = new THREE.Group();
    card.add(frontCover);
    card.add(backCover);
    card.add(insideLeft);
    card.add(insideRight);

    // Position the card group to make it sit on the table
    card.position.y = (0.5 + 0.01);  // scaled down
    
    scene.add(card);
};const createAcrylic = async () => {
    const loader = new THREE.TextureLoader();
    const uniqueId = Date.now(); // To force-refresh the cache
    const ecid = await processProduct('acrylic');
    const textureUrl = `https://i.expresscreations.co.uk/uploads/${ecid}-front_cover.png?${uniqueId}`;

    // Function to load texture
    const loadTexture = (url) => {
        return new Promise((resolve, reject) => {
            loader.load(
                url,
                (texture) => {
                    texture.wrapS = THREE.ClampToEdgeWrapping;
                    texture.wrapT = THREE.ClampToEdgeWrapping;
                    texture.needsUpdate = true;
                    resolve(texture);
                },
                undefined,
                reject
            );
        });
    };

    const acrylicTexture = await loadTexture(textureUrl);

    // Create a single material with transparency, applied to both sides of the mesh
    const acrylicMaterial = new THREE.MeshStandardMaterial({
        map: acrylicTexture,
        transparent: true,
        opacity: 0.95,
        metalness: 0.0,
        roughness: 0.5,
        // Use double-sided material to simplify
        side: THREE.DoubleSide
    });

    // Create a thin box geometry for the acrylic plaque
    const acrylicThickness = 0.05; // Very thin acrylic thickness
    const acrylicGeometry = new THREE.BoxGeometry(1, 1.4, acrylicThickness);

    // Create a mesh with the acrylic material
    const acrylic = new THREE.Mesh(acrylicGeometry, acrylicMaterial);

    // Adjust the position so the bottom of the plaque is at y=0
    acrylic.position.set(0, 0.7, 0);

    acrylic.castShadow = true;
    acrylic.receiveShadow = true;

    scene.add(acrylic);

    return acrylic;
};
const animateOrbit = () => {
    TWEEN.update();
    animationId = requestAnimationFrame(animateOrbit);
    if (!controls.autoRotateStopped) {
        theta += 0.005;
        const radius = 2.5;
        camera.position.x = radius * Math.sin(theta);
        camera.position.y = 1.2;
        camera.position.z = radius * Math.cos(theta);
        camera.lookAt(0, 0.5 + 0.01, 0);
    }
    composer.render();
};

const setupOrbitControls = () => {
    controls = new OrbitControls(camera, renderer.domElement);
    controls.autoRotateStopped = false;
    
    // Ensure the camera's y position is the same as during the animation when the user starts interacting
    controls.addEventListener('start', () => {
        controls.autoRotateStopped = true;
        camera.position.y = 2;  // Set the camera's y position to the same value as the animated one
    });
};


// Helper Functions
async function getCanvasDataURL(divId) {
    // Make sure the content is fully loaded before capturing
    return new Promise((resolve, reject) => {
        html2canvas(document.getElementById(divId)).then(canvas => {
            resolve(canvas.toDataURL('image/png'));
        }).catch(err => {
              console.error("html2canvas error: ", error);
            reject(err);
        });
    });
}
//initScene();

function onWindowResize() {

    return;//disable
    // Add logic to handle window resizing
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
    composer.setSize(window.innerWidth, window.innerHeight);
}

//window.addEventListener('resize', onWindowResize);
export function animate() {
    requestAnimationFrame(animate);
    TWEEN.update();
    // Update the camera's position


    composer.render();
}

function onDocumentMouseClick(event) {  
    event.preventDefault();
    // Debugging line
    console.log("Debug:", frontCover, backCover, insideLeft, insideRight);

    // return early if the objects aren't initialized
    if (!frontCover || !backCover || !insideLeft || !insideRight) {
        console.warn("One of the objects is not initialized.");
        return;
    }

    event.preventDefault();

    // Calculate mouse position in normalized device coordinates
    const mouse = new THREE.Vector2();
    mouse.x = (event.clientX / window.innerWidth) * 2 - 1;
    mouse.y = -(event.clientY / window.innerHeight) * 2 + 1;

    // Update the picking ray with the camera and mouse position
    const raycaster = new THREE.Raycaster();
    raycaster.setFromCamera(mouse, camera);

    // Calculate objects intersecting the picking ray
    const intersects = raycaster.intersectObjects([frontCover, backCover, insideLeft, insideRight]);
    
    console.log("Intersects:", intersects);  // Debug line
    
    if (intersects.length > 0) {
        console.log("Click recognized, object:", intersects[0].object);  // Debug line
        clickCardFace(intersects[0].object);
    }
}

export function close3DPreview() {
    console.log("Scene:", scene);
    console.log("Renderer:", renderer);

    // Dispatch an event to indicate that 3D rendering is deactivated
    const event = new Event('3dRenderingStatus');
    event.status = false;
    document.dispatchEvent(event);

    // Stop any animations
    cancelAnimationFrame(animationId);  // assuming animationId is the ID returned by requestAnimationFrame

    // Remove event listeners (if any)
    // For example: renderer.domElement.removeEventListener('click', onDocumentMouseClick, false);

    // Dispose of all geometries, materials, and textures
    if (scene) {
        scene.traverse((object) => {
            if (object.isMesh) {
                object.geometry.dispose();
                object.material.dispose();
            }
        });

        // Remove all children from the scene
        while(scene.children.length > 0){ 
            scene.remove(scene.children[0]); 
        }
    }

    // Remove the renderer
    if (renderer) {
        renderer.domElement.remove();
        renderer.dispose();
    }

    // Nullify global objects
    scene = null;
    camera = null;
    renderer = null;
    controls = null;  // Assuming you have controls
    composer = null;  // Assuming you have a composer

    // Set the flag to indicate 3D is not active
    is3DRenderingActive = false;
}


